import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

export const contentCard: SxProps<Theme> = (theme) => ({
  bgcolor: "background.paper",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 2.75,
  boxShadow: theme.shadows[3],
  p: { xs: 2, md: 2.75 },
  display: "flex",
  flexDirection: "column",
  gap: 2.25,
});

export const toolbar: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 1.75,
};

export const toolbarFilters: SxProps<Theme> = {
  display: "flex",
  flexWrap: "wrap",
  gap: 1,
};

export const searchWrap: SxProps<Theme> = {
  width: { xs: "100%", sm: 300 },
  maxWidth: "100%",
};

export const paginationFooter: SxProps<Theme> = {
  pt: 0.75,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 1.5,
};

export const paginationCount: SxProps<Theme> = {
  fontSize: "0.78125rem",
  color: "text.secondary",
};

export const infoBanner: SxProps<Theme> = (theme) => ({
  bgcolor: alpha(theme.palette.primary.main, 0.08),
  border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
  borderRadius: 2,
  p: theme.spacing(1.75, 2.25),
  display: "flex",
  alignItems: "center",
  gap: 1.5,
});

export const infoBannerText: SxProps<Theme> = {
  fontSize: "0.8125rem",
  lineHeight: 1.7,
};

export const emptyStateCard: SxProps<Theme> = (theme) => ({
  bgcolor: "background.paper",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 2.75,
  boxShadow: theme.shadows[3],
  p: { xs: 5, md: 8 },
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
  textAlign: "center",
  minHeight: 440,
});

export const emptyStateIconWrap: SxProps<Theme> = (theme) => ({
  width: 110,
  height: 110,
  borderRadius: 3.5,
  bgcolor: alpha(theme.palette.primary.main, 0.08),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  mb: 1,
});

export const iconButton: SxProps<Theme> = (theme) => ({
  width: 34,
  height: 34,
  borderRadius: 1.125,
  border: `1px solid ${theme.palette.divider}`,
  bgcolor: "background.paper",
  color: "text.secondary",
  p: 0,
  transition: "all 0.2s ease",
  "&:hover": {
    bgcolor: alpha(theme.palette.primary.main, 0.08),
    color: "primary.main",
    borderColor: alpha(theme.palette.primary.main, 0.3),
  },
});

export const iconButtonDanger: SxProps<Theme> = (theme) => ({
  width: 34,
  height: 34,
  borderRadius: 1.125,
  border: `1px solid ${theme.palette.divider}`,
  bgcolor: "background.paper",
  color: "text.secondary",
  p: 0,
  transition: "all 0.2s ease",
  "&:hover": {
    bgcolor: alpha(theme.palette.error.main, 0.1),
    color: "error.main",
    borderColor: theme.palette.error.main,
  },
});
